/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** @jsxImportSource @emotion/react */
import { Card, Typography, useTheme } from '@quickbit/qb-design-system';
import { JsonDiff } from './JsonDiff';

interface Props {
  record: any;
  previousRecord?: any;
}

export const HistoryDifferenceCard = ({ record, previousRecord }: Props) => {
  const { spacing, palette, shape } = useTheme();

  return (
    <Card>
      <div
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: spacing.xxxs,
        }}
      >
        <div css={{ display: 'flex', gap: spacing.xxxs, alignItems: 'center' }}>
          <Typography>{record.changeReason}</Typography>
          <Typography variant="bodySmallest">{record.changedBy}</Typography>
        </div>
        <Typography>{record.createdAt.toLocaleString()}</Typography>
      </div>
      {record.comment && (
        <div
          css={{
            display: 'flex',
            gap: spacing.xxxs,
            marginBottom: spacing.xxxs,
          }}
        >
          <Typography variant="bodySmallMedium">Comment:</Typography>
          <Typography variant="bodySmallMedium">{record.comment}</Typography>
        </div>
      )}
      <div
        css={{
          backgroundColor: palette.grey.x100,
          borderRadius: shape.borderRadius,
          padding: spacing.xxxs,
        }}
      >
        <JsonDiff
          oldObject={previousRecord ? previousRecord.record : {}}
          newObject={record.record}
        />
      </div>
    </Card>
  );
};
